import LayoutView from 'common/layouts/LayoutView';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from 'redux/slices/authSlice';
import { fetchFormContextAction } from 'redux/slices/formSlice';
import { fetchServiceTypesAction } from 'redux/slices/iCalendarV4';

import { fetchAvailabilitiesAction, getAvailabilitiesPending } from 'redux/slices/iCalendarV4/availabilitySlice';
import 'suneditor/dist/css/suneditor.min.css';
import MyAvailabilitySection from './MyAvailabilitySection';

const MyAvailability = ({ userData, showTotal }) => {
    const { userId, userView } = userData;
    const dispatch = useDispatch();
    const user = useSelector(getUser);
    const pending = useSelector(getAvailabilitiesPending);

    useEffect(() => {
        dispatch(fetchServiceTypesAction());
        dispatch(
            fetchFormContextAction({
                queryParams: {
                    type: 'service_extra_fields',
                },
            }),
        );
    }, [dispatch]);

    const loadData = useCallback(() => {
        dispatch(
            fetchAvailabilitiesAction({
                queryParams: {
                    calendarId: userId || user.userId,
                    expand: ['services'],
                },
            }),
        );
    }, [dispatch, user.userId, userId]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const section = (
        <MyAvailabilitySection
            userData={{ ...userData, userId: userData.userId || user.userId }}
            showTotal={showTotal}
            loadData={loadData}
        />
    );

    return <>{userView ? section : <LayoutView pending={pending}>{section}</LayoutView>}</>;
};

export default MyAvailability;
